import React, { useState } from 'react';

const DenominationSwitch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOperator, setSelectedOperator] = useState('all');
  
  const [switchingData, setSwitchingData] = useState([
    {
      id: 1,
      operator: 'Airtel',
      denomination: '10',
      apiProvider: 'API Provider 1',
      successRate: '98.5%',
      totalTransactions: 2500,
      status: 'Active',
      lastUpdated: '2025-11-05 10:30 AM'
    },
    {
      id: 2,
      operator: 'Vodafone',
      denomination: '20',
      apiProvider: 'API Provider 2',
      successRate: '97.2%',
      totalTransactions: 1800,
      status: 'Active',
      lastUpdated: '2025-11-05 09:15 AM'
    },
    {
      id: 3,
      operator: 'Jio',
      denomination: '50',
      apiProvider: 'API Provider 1',
      successRate: '99.1%',
      totalTransactions: 3200,
      status: 'Active',
      lastUpdated: '2025-11-05 08:45 AM'
    },
    {
      id: 4,
      operator: 'Airtel',
      denomination: '100',
      apiProvider: 'API Provider 3',
      successRate: '96.8%',
      totalTransactions: 1500,
      status: 'Active',
      lastUpdated: '2025-11-05 08:20 AM'
    },
    {
      id: 5,
      operator: 'BSNL',
      denomination: '500',
      apiProvider: 'API Provider 2',
      successRate: '95.5%',
      totalTransactions: 800,
      status: 'Inactive',
      lastUpdated: '2025-11-04 05:20 PM'
    }
  ]);

  const operators = ['all', ...new Set(switchingData.map(item => item.operator))];

  const filteredData = switchingData.filter(item => {
    const matchesSearch = 
      item.operator.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.denomination.includes(searchTerm) ||
      item.apiProvider.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesOperator = selectedOperator === 'all' || item.operator === selectedOperator;
    
    return matchesSearch && matchesOperator;
  });

  const handleStatusToggle = (id) => {
    setSwitchingData(switchingData.map(item => 
      item.id === id 
        ? { ...item, status: item.status === 'Active' ? 'Inactive' : 'Active' }
        : item
    ));
  };

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1">Denomination Switch</h2>
          <p className="text-muted mb-0">Manage API switching based on recharge denominations</p>
        </div>
        <button className="btn btn-primary">
          <i className="bi bi-plus-circle me-2"></i>
          Add Denomination Rule
        </button>
      </div>

      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Search</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by operator, denomination, or API provider..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label">Filter by Operator</label>
              <select
                className="form-select"
                value={selectedOperator}
                onChange={(e) => setSelectedOperator(e.target.value)}
              >
                {operators.map((operator, index) => (
                  <option key={index} value={operator}>
                    {operator === 'all' ? 'All Operators' : operator}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Rules</h6>
                  <h3 className="mb-0">{switchingData.length}</h3>
                </div>
                <i className="bi bi-cash-stack fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-success text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Active Rules</h6>
                  <h3 className="mb-0">
                    {switchingData.filter(item => item.status === 'Active').length}
                  </h3>
                </div>
                <i className="bi bi-check-circle-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-info text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Transactions</h6>
                  <h3 className="mb-0">
                    {switchingData.reduce((sum, item) => sum + item.totalTransactions, 0)}
                  </h3>
                </div>
                <i className="bi bi-graph-up fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-warning text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Avg Success Rate</h6>
                  <h3 className="mb-0">97.8%</h3>
                </div>
                <i className="bi bi-trophy-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Operator</th>
                  <th>Denomination</th>
                  <th>API Provider</th>
                  <th>Success Rate</th>
                  <th>Transactions</th>
                  <th>Status</th>
                  <th>Last Updated</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item) => (
                    <tr key={item.id}>
                      <td>#{item.id}</td>
                      <td>
                        <i className="bi bi-phone-fill text-primary me-2"></i>
                        {item.operator}
                      </td>
                      <td>
                        <span className="badge bg-success">₹{item.denomination}</span>
                      </td>
                      <td>{item.apiProvider}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="progress flex-grow-1 me-2" style={{height: '8px', width: '80px'}}>
                            <div 
                              className="progress-bar bg-success" 
                              style={{width: item.successRate}}
                            ></div>
                          </div>
                          <small>{item.successRate}</small>
                        </div>
                      </td>
                      <td>
                        <span className="badge bg-primary">{item.totalTransactions}</span>
                      </td>
                      <td>
                        <span className={`badge ${
                          item.status === 'Active' ? 'bg-success' : 'bg-danger'
                        }`}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <small className="text-muted">{item.lastUpdated}</small>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm" role="group">
                          <button className="btn btn-outline-primary" title="Edit">
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button 
                            className={`btn ${
                              item.status === 'Active' ? 'btn-outline-danger' : 'btn-outline-success'
                            }`}
                            onClick={() => handleStatusToggle(item.id)}
                            title={item.status === 'Active' ? 'Deactivate' : 'Activate'}
                          >
                            <i className={`bi ${
                              item.status === 'Active' ? 'bi-toggle-on' : 'bi-toggle-off'
                            }`}></i>
                          </button>
                          <button className="btn btn-outline-danger" title="Delete">
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-5">
                      <i className="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                      <p className="text-muted mb-0">No denomination rules found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted">
              Showing {filteredData.length} of {switchingData.length} rules
            </div>
            <div>
              <button className="btn btn-sm btn-outline-primary me-2">
                <i className="bi bi-download me-1"></i>
                Export
              </button>
              <button className="btn btn-sm btn-outline-secondary">
                <i className="bi bi-arrow-clockwise me-1"></i>
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DenominationSwitch;

